import React from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import './ConversationPrint.css';

/**
 * Component to display a printable version of the conversation in Apple document style
 */
const ConversationPrint = ({
  isLoading,
  content,
  onRefresh
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <AiOutlineLoading3Quarters className="animate-spin h-8 w-8 text-blue-500" />
      </div>
    );
  }

  if (!content) {
    return (
      <div className="text-gray-500 text-center p-8 font-light">
        Keine Inhalte verfügbar. Klicken Sie auf "Aktualisieren", um den Druckinhalt zu generieren.
      </div>
    );
  }

  if (content.success === false) {
    return (
      <div className="p-4 m-4 text-red-700">
        <h3 className="font-medium mb-2">Fehler beim Generieren des Druckinhalts</h3>
        <p className="text-sm">{content.error || "Unbekannter Fehler ist aufgetreten"}</p>
      </div>
    );
  }

  const formattedDate = content.created_at && new Date(content.created_at).toLocaleDateString('de-CH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="conversation-print-panel">
      <div className="conversation-print">
        <div className="conversation-header">
          <h1>{content.conversationName || 'Konversation'}</h1>
          <p>{formattedDate}</p>
        </div>

        <div className="conversation-messages">
          {content.messages.map((msg, idx) => (
            <div key={idx} className={`message ${msg.role}`}>
              <div className="message-role">
                {msg.role === 'user' ? 'Sie' : 'Bernie\'s AI'}
              </div>
              <div
                className="message-content"
                dangerouslySetInnerHTML={{ __html: msg.content }}
              />
            </div>
          ))}
        </div>

        <div className="conversation-footer">
          Bernie's AI by Quantonomics
        </div>
      </div>
    </div>
  );
};

export default ConversationPrint;
